// src/store/index.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice"; // Optional if needed
import stagesReducer from "./slices/providersSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    stages: stagesReducer,
  },
});

export default store;
